/** Safer alternative for isArray that narrows the type to `unknown[]` instead of `any[]` */
export const isArray: (value: unknown) => value is unknown[] = Array.isArray
